var React = require('react');

function Gatsby (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12.001.007c-6.675 0-11.994 5.319-11.994 11.993s5.319 11.995 11.993 11.995 11.994-5.319 11.994-11.994-5.318-11.994-11.993-11.994zm-9.387 12.098 9.283 9.283c-5.111 0-9.283-4.172-9.283-9.283zm11.473 9.074-11.264-11.264c.937-4.172 4.693-7.301 9.177-7.301a9.476 9.476 0 0 1 7.614 3.86l-1.355 1.146a7.657 7.657 0 0 0 -6.362-3.337 7.555 7.555 0 0 0 -7.197 5.11l9.804 9.805c2.4-.835 4.276-2.92 4.798-5.424h-4.068v-1.773h6.154c0 4.485-3.129 8.24-7.301 9.178z"}));
}

Gatsby.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Gatsby;

Gatsby.default = Gatsby;
